/* ---------------------------------------------------------------------------
 * Sticky add to cart, mobile product pages only.
 *
 * The real button sits ~1,857px down a 4,435px page, so once a shopper
 * scrolls past it into the description there is no way back to it without
 * scrolling up. This mirrors it in a fixed bar.
 *
 * It appears only once the real button has scrolled off the TOP of the
 * screen, not merely because the button is further down the page. That
 * matters: the bar is 74px tall and the price sits at 786px on an 844px
 * screen, so a bar shown at page load would cover the price we just worked
 * to lift above the fold.
 *
 * The bar never submits anything itself. It clicks the real button, so the
 * options app's handler and the required-options guard in
 * product-options-extension.js both still run: an incomplete shaft is
 * blocked from the bar exactly as it is from the button.
 *
 * Deliberately a throttled scroll listener rather than IntersectionObserver.
 * IO delivery is tied to the rendering lifecycle, which made it impossible to
 * verify in a headless pane; a scroll listener behaves identically here and
 * on a real device, and the condition is a single threshold.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-product')) return;

  var MQ = window.matchMedia('(max-width:749px)');

  // The options app renders a hidden twin of the button and swaps between
  // them, so never cache the element: pick the last visible one each time.
  function visibleAtc() {
    var list = document.querySelectorAll('.button-add-to-cart');
    for (var i = list.length - 1; i >= 0; i--) {
      if (list[i].offsetHeight > 0) return list[i];
    }
    return null;
  }

  function priceText() {
    var el =
      document.querySelector('.price .price-item-regular') ||
      document.querySelector('.price .price-item') ||
      document.querySelector('.price');
    if (!el) return '';
    var m = el.textContent.replace(/\s+/g, ' ').match(/\$[\d.,]+/);
    return m ? m[0] : '';
  }

  // Anchor to the container, not the button: the app replaces the button.
  var anchor = document.querySelector('.product-actions-add-to-cart');
  var first = visibleAtc();
  if (!anchor || !first) return;

  var bar = document.createElement('div');
  bar.className = 'tqg-stickybuy';
  bar.setAttribute('data-show', 'false');

  var price = document.createElement('span');
  price.className = 'tqg-stickybuy__price';
  price.textContent = priceText();

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'tqg-stickybuy__btn';
  btn.textContent = (first.textContent || '').trim() || 'Add to cart';

  bar.appendChild(price);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  btn.addEventListener('click', function () {
    var live = visibleAtc();
    if (live) live.click();
  });

  function update() {
    var scrolledPast = anchor.getBoundingClientRect().bottom < 0;
    var on = scrolledPast && MQ.matches;
    bar.setAttribute('data-show', on ? 'true' : 'false');
    // Only pad the page while the bar is actually covering the bottom.
    document.body.classList.toggle('tqg-has-stickybuy', on);
  }

  var waiting = false;
  function onScroll() {
    if (waiting) return;
    waiting = true;
    setTimeout(function () {
      waiting = false;
      update();
    }, 80);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (MQ.addEventListener) {
    MQ.addEventListener('change', update);
  } else if (MQ.addListener) {
    MQ.addListener(update);
  }

  // The options app rewrites the price as choices are made, so follow it.
  var priceEl = document.querySelector('.price');
  if (priceEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      price.textContent = priceText();
    }).observe(priceEl, { childList: true, subtree: true, characterData: true });
  }

  update();
})();
